<template>
    <div class="article-blog-renegades">
        <p>
            I’ve danced West Coast Swing to just about every musical style there is.&nbsp;Pop, rock, blues, ballads,
            disco, funk, house, hip-hop and everything in between.&nbsp;The one style of music I don’t hear a lot of, is
            erm, ‘swing’. So where does West Coast Swing fit in the swing dance family?
        </p>
        <p>
            The swing dances are a group of dance styles, developed with the swing style of jazz in the 1920s, 1930s and
            1940s.&nbsp;At the time there were hundreds of different styles of swing dancing – and some like the Lindy
            Hop, Balboa, Shag and Charleston are still danced and celebrated today.
        </p>
        <p>
            Perhaps the most influential of the original swing dances, the Lindy Hop is considered to be the great
            grandfather of all swing dances.&nbsp;As a keen but rusty Lindy Hop dancer, I can clearly see the influences
            of the dance in West Coast Swing.
        </p>
        <p>
            But while the Lindy Hop is still danced to the big band swing music of its birth, West Coast Swing is a
            living dance that has constantly moved with the music of the day.&nbsp;As the music has changed, so has the
            dance.&nbsp;At a West Coast Swing social today you might not hear a swung beat very often, let alone classic
            swing.
        </p>
        <p>
            So where does West Coast Swing fit?&nbsp;Well, if Lindy Hop is the great grandfather of swing, then West
            Coast Swing is the rebellious, carefree great granddaughter.&nbsp;And fun history lessons aside, we love it
            – whatever it is!
        </p>
        <p>
            <em>To read more on the history of the dance, check out Sonny Watson’s excellent </em
            ><a href="https://www.streetswing.com/" target="_blank" rel="noopener noreferrer nofollow"
                ><em>streetswing.com</em></a
            ><em> website.</em>
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleBlogRenegades',
};
</script>
